import { UserBasic } from '../../../../../lib/functions/user'

/**
 * スプリントラベルをフォーマットする
 * 日付がある場合: "スプリント名（MM/DD～MM/DD）"
 * 日付がない場合: "スプリント名"
 */
export const formatSprintLabel = (
  sprintName: string,
  startDate: string,
  endDate: string,
  formatDate: (dateStr: string) => string
): string => {
  if (!startDate) return sprintName
  return `${sprintName}（${formatDate(startDate)}～${formatDate(endDate)}）`
}

export type ViewMode = 'workload' | 'selection'

/** スプリント選択モード用（スプリント単位） */
export interface SprintSelectionItem {
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  checked: boolean
}

/** 工数入力モード用（SPI単位） */
export interface SpiAdjustmentItem {
  /** SPI UUID（新規の場合は仮UUID） */
  uuid: string
  sprintUuid: string
  sprintName: string
  startDate: string
  endDate: string
  estimatedHour: number
  assignee: UserBasic | null
  /** 新規追加かどうか */
  isNew: boolean
}
